import clsx from 'clsx'
import PropTypes from 'prop-types'

import { Tab, Typography, Box } from '@mui/material'

import useTranslations from '../../../i18n/useTranslations'

import useStyles from './styles'
import { DISABLED, ENABLED, SUCCESS, ERROR, ICONS } from './constants'

const Step = ({ name, value, title, subtitle, index, status, ...props }) => {
  const t = useTranslations()
  const classes = useStyles({ status })

  return (
    <Tab
      className={clsx(classes.tab, classes[status])}
      {...props} // Necessary for tabs to work
      value={value}
      label={
        <Box className={classes.tabLabel}>
          <Typography className={classes.title} variant="h2" gutterBottom>
            {t(title)}
          </Typography>
          <Typography className={classes.subtitle} variant="body1">
            {t(subtitle)}
          </Typography>
        </Box>
      }
      icon={
        <Box component="span" className={classes.indicator}>
          {ICONS[status] ? ICONS[status] : index + 1}
        </Box>
      }
      disabled={status === DISABLED}
    />
  )
}

Step.STATUS = { DISABLED, ENABLED, SUCCESS, ERROR }

Step.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  status: PropTypes.string.isRequired,
}

export default Step
